import { publicClient } from '../utils/chain-client';
import { useWallet } from './use-wallet';
import { useQuery } from '@tanstack/react-query';
import { Address, erc20Abi } from 'viem';

export const useSignedAllowance = (tokenAddress?: string, spenderAddress?: string) => {
  const { address } = useWallet();
  return useQuery({
    enabled: Boolean(address) && Boolean(tokenAddress) && Boolean(spenderAddress),
    queryKey: ['allowance', tokenAddress, address, spenderAddress],
    queryFn: async () =>
      publicClient.readContract({
        address: tokenAddress as Address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [address as Address, spenderAddress as Address],
      }),
  });
};
